import * as React from 'react'


type ImiSidePanelContextValue = {
  selectedDriverIds: string[]
  setSelectedDriverIds: (ids: string[]) => void

  driverTableKey: number
  bumpDriverTableKey: () => void
}

const ImiSidePanelContext =
  React.createContext<ImiSidePanelContextValue | null>(null)

export const ImiSidePanelProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [selectedDriverIds, setSelectedDriverIds] = React.useState<string[]>([])
  const [driverTableKey, setDriverTableKey] = React.useState(0)

  const bumpDriverTableKey = React.useCallback(
    () => setDriverTableKey((key) => key + 1),
    [],
  )

  const value = React.useMemo(
    () => ({
      selectedDriverIds,
      setSelectedDriverIds,
      driverTableKey,
      bumpDriverTableKey,
    }),
    [selectedDriverIds, driverTableKey, bumpDriverTableKey],
  )

  return (
    <ImiSidePanelContext.Provider value={value}>
      {children}
    </ImiSidePanelContext.Provider>
  )
}

export const useImiSidePanel = (): ImiSidePanelContextValue => {
  const context = React.useContext(ImiSidePanelContext)
  if (!context) {
    throw new Error('useImiSidePanel must be used within an ImiSidePanelProvider')
  }
  return context
}
